export const BASE_URL = "https://web1024.docmaster.in:5010";

// export const BASE_URL ="http://localhost:5010";

// export const CAL_URL ="http://localhost:5007";

export const CAL_URL = "https://web1024.docmaster.in:5007";

export const API_URL = "https://web1024.docmaster.in:5000";

export const Ticketing_API_URL = "https://web1024.docmaster.in:4501";
// export const Ticketing_API_URL = "http://localhost:4501";
// export const Ticketing_API_URL =
//   "https://musicians-than-characteristics-invention.trycloudflare.com";
export const Testimonials_BASE_URL = "https://web1024.docmaster.in:5007";

// export const API_URL_QUESTION_BANK = "https://web1024.docmaster.in:5010/api";
export const getStatus = `${BASE_URL}/general/campaign-form-status/`;

export const sponsorshipRegistration = `${BASE_URL}/general/grants-sponsorships-registration`;
export const csrRegistration = `${BASE_URL}/general/csr-school-registration`;
export const partnershipRegistration = `${BASE_URL}/general/partnership-registration`;

export const SCHOOL_QUIZ_API_BASE_URL =
  "https://web1024.docmaster.in:5007/api/school/quiz/admin";

  
export const UTILITY_URL = "http://localhost:5100";
